<template>
  <MDBModal id="openModaL" tabindex="-1" labelledby="exampleModalCenterTitle" v-model="openModaL" centered
    staticBackdrop role="alertdialog" aria-modal="true">
    <MDBModalHeader style="background-color: #c4bfbf; border-bottom: #c4bfbf;" />

    <MDBModalBody style="font-size: 2vh; background-color: #c4bfbf;">
      <h4 v-if="submitSuccess" style="color: #0c0c72;">
        <i class="far fa-check-circle"></i>
        <b>Vaše hlášení bylo úspěšně odesláno!</b>
      </h4>
      <h4 v-else style="color: red;">
        <i class="far fa-check-circle"></i>
        <b>Došlo k chybě na straně serveru</b>
      </h4>
    </MDBModalBody>

    <MDBModalFooter style="font-size: 2vh; background-color: #c4bfbf; border-top: #c4bfbf;" />
  </MDBModal>

  <div class="form-body">
    <h1 style="color: #0c0c72;font-size:38px;" class="fw-normal">PODÁNÍ OZNÁMENÍ</h1>
    <br />
    <br />

    <h3 class="fw-bolder">Informace před podáním oznámení</h3>
    <p class="fw-bolder">Jaké povinnosti má oznamovatel?</p>
    <p>
      Oznamující osoba by vzhledem k okolnostem a informacím, které má k
      dispozici v době oznámení, měla mít pádný důvod se domnívat, že jí
      oznamované či zveřejňované skutečnosti jsou autentické a pravdivé. Nelze
      tedy oznamovat skutečnosti vědomě nepravdivé. Takovéto jednání může být
      sankcionováno.
    </p>
    <p>
      Při získávání dokladů dokládajících oznamované skutečnosti by se
      oznamovatel neměl dopustit jednání, které by mohlo mít charakter trestného
      činu.
    </p>
    <p>
      Oznamovatel by měl jednat ve veřejném zájmu a v dobré víře, že jím
      podávané oznámení se opírá o věrohodná fakta a skutečnosti.
    </p>
    <p>
      Oznamovatel by měl být schopen identifikovat, jaké oblasti se protiprávní
      jednání týká a promyslet jaké ověřitelné informace o ohlašovaném
      protiprávním jednání může poskytnout. Rozsah a kvalita předkládaných
      informací mohou pozitivně ovlivnit způsob prošetření oznámení.
    </p>
    <br>

    <p>
      Více informací, odpovědi na nejčastější otázky a mnoho dalšího lze nalézt na webové stránce Ministerstva
      spravedlnosti <a href="https://oznamovatel.justice.cz/">https://oznamovatel.justice.cz/</a>.
    </p>

    <br><br>
    <h2 class="fw-bolder" style="font-size: 16px;">Zabezpečený formulář pro učinění oznámení</h2>
    <br />

    <form @submit="submit" role="form">
      <BaseInput label="Jméno a příjmení" v-model="nameAndSurname" :error="errors.nameAndSurname" type="text"
        :required="true" />

      <BaseInput label="Datum narození" type="text" v-model="narozen" :error="errors.narozen" :required="true" />

      <BaseInput label="Email" type="email" v-model="email" :error="errors.email" :required="true" />

      <BaseInput label="Telefon" type="text" v-model="phone" :error="errors.phone" />

      <BaseInput label="Poštovní / kontaktní adresa" v-model="address" :error="errors.address" type="text" />

      <BaseTextArea label="Text oznámení" v-model="description" :error="errors.description" type="text" :required="true"
        class="p-3" />

      <label for="fileinput" class="label" aria-label="Nahrávání příloh">Přílohy</label>

      <file-pond name="fileinput" ref="pond" label-idle="Vyberte / přetáhněte soubory sem" v-bind:allow-multiple="true"
        accepted-file-types="text/plain, text/csv, image/*, video/*, audio/*, application/pdf, application/msword, application/vnd.ms-powerpoint, application/vnd.ms-excel, zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        v-on:init="handleFilePondInit" />
      <p>
        Přiložte veškeré relevantní důkazy prokazující skutečnosti uvedené v oznámení
      </p>
      <p>
        Povolené jsou následující typy souborů: .png, .gif, .jpg, .doc, .docx, .xls, .ppt, .pdf, .txt, .wav, .mp3, .mp4,
        .mpg, .mov, .wmv, .7zip, .rar, .xxs
      </p>
      <p>
        Maximální velikost nahrávaných souborů je 25MB.
      </p>
      <br>
      <div>
        <BaseCheckbox
          label="ochrana před odvetnými opatřeními se nevztahuje na osobu, která vědomě učinila nepravdivé oznámení"
          v-model="protection" :error="errors.protection" :required="true" />
      </div>

      <br>

      <p class="reqField">* označená pole jsou povinná</p>

      <div>
        <BaseButton v-bind:disabled="submitted" type="submit" class="-fill-gradient" something="else" @click="submit"
          value="Submit">
          Odeslat
        </BaseButton>

      </div>
    </form>
    <br />
    <br />
    <br />
    <table>
      <tr>
        <td class="text-white" style="background-color: #0c0c72;" colspan="2">Další možné formy podání
          oznámení</td>
      </tr>
      <tr>
        <td>Příslušná osoba:</td>
        <td>Ing. Šárka Nováková, MBA</td>
      </tr>
      <tr>
        <td>E-mail (písemné podání):</td>
        <td>whistleblowing@vfn.cz</td>
      </tr>
      <tr>
        <td>Telefonické spojení (ústní podání):</td>
        <td>224 965 472</td>
      </tr>
      <tr>
        <td>Osobně:</td>
        <td>Po telefonické domluvě s příslušnou osobou, nejpozději do 14 dnů ode dne, kdy o to oznamovatel požádá.</td>
      </tr>
      <tr>
        <td>Listovní zásilkou (písemně) na adresu nemocnice:<br>
          (obálku nutno označit <span class="reqField">„NEOTEVÍRAT WHISTLEBLOWING“</span>)</td>
        <td>Ing. Šárka Nováková, MBA<br>
          U Nemocnice 499/2<br>
          128 08 Praha 2</td>
      </tr>

    </table>







  </div>
</template>

<script>
import { useForm, useField } from 'vee-validate'
import { ref, onMounted } from 'vue'
import * as yup from 'yup'
import ApiService from '@/services/ApiService'
import StatusCodes from 'http-status-codes'

import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginFileEncode from 'filepond-plugin-file-encode'
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata'

import {
  MDBModal,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter
} from 'mdb-vue-ui-kit'

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileEncode,
  FilePondPluginFileMetadata
)

export default {
  components: {
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    FilePond
  },

  methods: {
    handleFilePondInit: function () {
    },
  },
  
  
  setup() {
    const submitted = ref(false)
    const openModaL = ref(false)
    const submitSuccess = ref(false)
    const pond = ref(null);

    onMounted(() => {
    });

    const validationSchema = yup.object({
      nameAndSurname: yup.string().required('Toto pole je povinné'),
      email: yup
        .string()
        .matches(
          /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          'Vložte platný email'
      ).required('Toto pole je povinné'),
      phone: yup
        .string()
        .matches(/^$|^[0-9 ()+-]+$/, 'Vložte platné telefonní číslo'),
      narozen: yup.string().required('Toto pole je povinné'),
      address: yup.string(),
      description: yup.string().required('Toto pole je povinné'),
      protection: yup.boolean().oneOf([true], 'Toto pole je povinné'),
    })
    const { handleSubmit, errors } = useForm({
      validationSchema,
      initialValues: {
        protection: false,
      },
    })
    const { value: nameAndSurname } = useField('nameAndSurname')
    const { value: narozen } = useField('narozen')
    const { value: email } = useField('email')
    const { value: phone } = useField('phone')
    const { value: address } = useField('address')
    const { value: description } = useField('description')
    const { value: protection } = useField('protection')


    const submit = handleSubmit(async (values, { resetForm }) => {
      submitted.value = true
      grecaptcha.ready(function () {
        grecaptcha.execute('6Le9DN4mAAAAAFFratf5N0UvoOArCMjNbrBbwtbW', { action: 'submit' }).then(async function (token) {
          // Add your logic to submit to your backend server here.
          console.log(token)
          let files = pond.value.getFiles()
          let filesArray = []

          if (files.length > 0) {
            files.forEach((file, i) => {
              filesArray.push({
                fileExtension: file.fileExtension,
                fileType: file.fileType,
                Name: `priloha${i}.${file.fileExtension}`,
                ContentBytes: file.getFileEncodeBase64String()
              })
            })
          }

          values.filesArray = filesArray

          try {
            values.recaptchaResponse = token
            const result = await ApiService.sendData(values)

            if(result.request.status===StatusCodes.ACCEPTED){
              openModaL.value = true
              submitSuccess.value = true
              resetForm()
              pond.value.removeFiles()
              submitted.value = false
            } else {
              openModaL.value = true
              submitSuccess.value = false
              submitted.value = false
            }

          } catch (error) {
            openModaL.value = true
            submitSuccess.value = false
            submitted.value = false
          }
        });
      });

      return false


    })

    return {
      nameAndSurname,
      narozen,
      email,
      phone,
      address,
      description,
      protection,
      errors,
      submit,
      handleSubmit,
      openModaL,
      submitSuccess,
      pond,
      submitted
    }
  },
}
</script>

<style>
.form-body {
  box-sizing: border-box;
  width: 60vw;
  padding: 0 20px 20px;
  margin: 0 auto;
}

.label {
  color: black;
}

.filefield {
  border: 0;
}

.reqField {
  font-size: 2vh;
  color: #9E0000;
}
table, th, td, tr {
  border: 1px solid #0c0c72;
  padding: 8px;
}
</style>
